import { createRouter, createWebHistory } from 'vue-router'
import store from '../store/index'
let viewType = 'web'
if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
  viewType = 'mobile'
}

const routes = [
  {
    path: '/',
    name: 'base',
    component: () => import(`../views/${viewType}/PageBasic.vue`),
    children: [
      {
        // 首頁
        path: '/',
        name: 'home',
        component: () => import(`../views/${viewType}/Index.vue`)
      },
      {
        // 關於我們
        path: '/about',
        name: 'about',
        component: () => import(`../views/${viewType}/AboutView.vue`)
      },
      {
        // 關於我們-品牌故事
        path: '/about/story',
        name: 'aboutstory',
        component: () => import(`../views/${viewType}/AboutStoryView.vue`)
      },
      {
        // 關於我們-公益合作
        path: '/about/welfare',
        name: 'aboutwelfare',
        component: () => import(`../views/${viewType}/AboutWelfareView.vue`)
      },
      {
        // 關於我們-創業講堂
        path: '/about/pioneer',
        name: 'aboutpioneer',
        component: () => import(`../views/${viewType}/AboutPioneerView.vue`)
      },
      {
        // 商品列表
        path: '/product',
        name: 'product',
        query: { parent_categry_id: '' },
        component: () => import(`../views/${viewType}/ProductView.vue`)
      },
      {
        // 商品詳情
        path: '/product/details',
        name: 'productdetails',
        component: () => import(`../views/${viewType}/ProductDetailsView.vue`)
      },
      {
        // 購物車
        path: '/cart',
        name: 'cart',
        component: () => import(`../views/${viewType}/CartView.vue`)
      },
      // {
      //   // 結帳頁
      //   path: '/checkout',
      //   name: 'checkout',
      //   component: () => import(`../views/${viewType}/CheckoutView.vue`)
      // },
      {
        // 訂單完成
        path: '/orderfinish',
        name: 'orderfinish',
        component: () => import(`../views/${viewType}/OrderFinishView.vue`)
      },
      {
        // 快速下單
        path: '/quickorder',
        name: 'quickorder',
        component: () => import(`../views/${viewType}/QuickOrderView.vue`)
      },
      {
        // 最新消息
        path: '/news',
        name: 'news',
        component: () => import(`../views/${viewType}/NewsView.vue`)
      },
      {
        // 最新消息詳情
        path: '/news/details',
        name: 'newsDetails',
        component: () => import(`../views/${viewType}/NewsDetailsView.vue`)
      },
      {
        // 活動公告
        path: '/activity',
        name: 'activity',
        component: () => import(`../views/${viewType}/ActivityView.vue`)

      },
      {
        // 活動公告詳情
        path: '/activity/details',
        name: 'activitydetails',
        component: () => import(`../views/${viewType}/ActivityDetailsView.vue`)

      },
      {
        // 聯絡我們
        path: '/contactus',
        name: 'contactus',
        component: () => import(`../views/${viewType}/ContactUsView.vue`)

      },
      {
        // 隱私條款
        path: '/terms',
        name: 'terms',
        component: () => import(`../views/${viewType}/TermsView.vue`)

      },
      {
        // 陌生客查詢訂單
        path: '/stranger',
        name: 'strangerinquiry',
        component: () => import(`../views/${viewType}/StrangerView.vue`)

      },
      {
        // 經銷商註冊
        path: '/register',
        name: 'register',
        component: () => import(`../views/${viewType}/RegisterView.vue`)
      },
      {
        // 經銷商登入
        path: '/login',
        name: 'login',
        component: () => import(`../views/${viewType}/LoginView.vue`)
      },
      {
        // 忘記密碼
        path: '/password',
        name: 'password',
        component: () => import(`../views/${viewType}/PasswordView.vue`)
      },
      {
        // 手機版index
        path: '/phome',
        name: 'phome',
        component: () => import(`../views/${viewType}/PhomeView.vue`)
      },
      {
        path: '/index',
        name: 'index',
        component: () => import(`../views/${viewType}/Index.vue`)
      },
      {
        path: '/test',
        name: 'test',
        component: () => import(`../views/test/TeatBank.vue`)
      },
      {
        path: `/member/profile_complete`,
        name: `member_profile_complete`,
        component: () => import(`../views/${viewType}/member/ProfileComplete.vue`)
      },
      {
        // 分享網址
        path: '/lineshare',
        name: 'lineshare',
        component: () => import(`../views/line/LineShare.vue`)
      },
      getMember()
    ],

  },

  {
    // line 綁定 (暫停)
    path: '/line',
    name: 'line',
    component: () => import(`../views/line/LineView.vue`)
  },
  // , {
  //   path: '/submall',
  //   name: 'subBase',
  //   component: () => import(`../views/${viewType}/PageBasic.vue`),
  //   children: [
  //     {
  //       // 個人子商城
  //       path: '/submall',
  //       name: 'submall',
  //       component: () => import(`../views/${viewType}/SubMallView.vue`)
  //     },
  //     {
  //       // 個人子商城
  //       path: '/submall/product',
  //       name: 'submallProduct',
  //       component: () => import(`../views/${viewType}/SubMallView.vue`)
  //     },
  //     {
  //       // 子商城登入
  //       path: '/submall/login',
  //       name: 'submallLogin',
  //       component: () => import(`../views/${viewType}/RegisterLoginView.vue`)
  //     },
  //     {
  //       // 子商城註冊
  //       path: '/submall/register',
  //       name: 'submallRegister',
  //       component: () => import(`../views/${viewType}/RegisterLoginView.vue`)
  //     },
  //     getMember(subName)
  //   ]
  // }
]

function getMember (name) {
  // 預設名稱
  let pathName = ''
  let onlyName = 'member'
  if (name) {
    pathName = `/${name}`
    onlyName = `${name}`
  }
  const memberObject = {
    path: `${pathName}/member`,
    name: `${name}_member_base`,
    component: () => import(`../views/${viewType}/member/MemberBasic.vue`),
    children: [
      {
        // 會員中心
        path: `${pathName}/member/account_overview`,
        name: `${onlyName}_account_overview`,
        component: () => import(`../views/${viewType}/member/AccountOverviewView.vue`)
      },
      {
        // 會員中心
        path: `${pathName}/member`,
        name: `${onlyName}_account`,
        component: () => import(`../views/${viewType}/member/IndexView.vue`)
        // component: () => import(`../views/${viewType}/member/AccountView.vue`)
      },
      {
        // 經銷商
        path: `${pathName}/member/dealer_account`,
        name: `${onlyName}_dealer_account`,
        component: () => import(`../views/${viewType}/member/DealerAccountView.vue`)
      },
      {
        // 常用地址
        path: `${pathName}/member/address`,
        name: `${onlyName}_address`,
        component: () => import(`../views/${viewType}/member/AddressView.vue`)
      },
      {
        //  通知總覽
        path: `${pathName}/member/notice`,
        name: `${onlyName}_notice`,
        component: () => import(`../views/${viewType}/member/NoticeView.vue`)
      },
      {
        // 購買清單
        path: `${pathName}/member/buy_list`,
        name: `${onlyName}_buy_list`,
        component: () => import(`../views/${viewType}/member/BuyListView.vue`)
      },
      {
        // 我的抽獎券
        path: `${pathName}/member/my_ticket`,
        name: `${onlyName}_my_ticket`,
        component: () => import(`../views/${viewType}/member/MyTicketView.vue`)
      },
      {
        //
        path: `${pathName}/member/favorite`,
        name: `${onlyName}_favorite`,
        component: () => import(`../views/${viewType}/member/FavoriteView.vue`)
      },
      {
        //
        path: `${pathName}/member/point`,
        name: `${onlyName}_point`,
        component: () => import(`../views/${viewType}/member/PointView.vue`)
      },
      {
        // 推薦圖
        path: `${pathName}/member/refer`,
        name: `${onlyName}_refer`,
        component: () => import(`../views/${viewType}/member/ReferView.vue`)
      },
      {
        // 推薦列表
        path: `${pathName}/member/refer_list`,
        name: `${onlyName}_refer_list`,
        component: () => import(`../views/${viewType}/member/ReferListView.vue`)
      },
      {
        // 月獎金
        path: `${pathName}/member/month_point`,
        name: `${onlyName}_month_point`,
        component: () => import(`../views/${viewType}/member/MonthPointView.vue`)
      },
      {
        // 賬號綁定
        path: `${pathName}/member/account_binding`,
        name: `${onlyName}_account_binding`,
        component: () => import(`../views/${viewType}/member/AccountBindingView.vue`)
      },
      {
        // 訂單詳情
        path: `${pathName}/member/order_detail`,
        name: `${onlyName}_order_detail`,
        component: () => import(`../views/${viewType}/member/OrderDetailView.vue`)
      },
      {
        // 配送進度
        path: `${pathName}/member/delivery_progress`,
        name: `${onlyName}_delivery_progress`,
        component: () => import(`../views/${viewType}/member/DeliveryProgressView.vue`)
      },
      {
        // 經銷商雲倉庫 ok
        path: `${pathName}/member/depot_cloud`,
        name: `${onlyName}_depot_cloud`,
        component: () => import(`../views/${viewType}/member/DepotCloudView.vue`)
      },
      {
        // 經銷商雲倉出入存紀錄 ok
        path: `${pathName}/member/depot_record`,
        name: `${onlyName}_depot_record`,
        component: () => import(`../views/${viewType}/member/DepotRecordView.vue`)
      },
      {
        // 經銷商雲倉庫 – 提貨 ok
        path: `${pathName}/member/pick_up`,
        name: `${onlyName}_pick_up`,
        component: () => import(`../views/${viewType}/member/PickUpView.vue`)
      },
      {
        // 經銷商雲倉庫 – 提貨申請紀錄
        path: `${pathName}/member/pickup_record`,
        name: `${onlyName}_pickup_record`,
        component: () => import(`../views/${viewType}/member/PickUpRecordView.vue`)
      },
      {
        // 經銷商雲倉庫 – 經銷商個人倉庫 – 1 ok
        path: `${pathName}/member/i_depot`,
        name: `${onlyName}_i_depot`,
        component: () => import(`../views/${viewType}/member/IDepotView.vue`)
      },
      {
        // 經銷商雲倉庫 – 經銷商個人倉出入存紀錄 ok
        path: `${pathName}/member/idepot_stock`,
        name: `${onlyName}_idepot_stock`,
        component: () => import(`../views/${viewType}/member/IDepotStockView.vue`)
      },
      {
        // 經銷商-我是賣家 - 全部
        path: `${pathName}/member/seller`,
        name: `${onlyName}_seller`,
        component: () => import(`../views/${viewType}/member/SellerView.vue`)
      },
      {
        // 經銷商--經銷商-我是賣家 -訂單詳情
        path: `${pathName}/member/seller_detail`,
        name: `${onlyName}_seller_detail`,
        component: () => import(`../views/${viewType}/member/SellerDetailView.vue`)
      },
      {
        // 經銷商--經銷商-我是賣家 -配送資訊
        path: `${pathName}/member/seller_delivery`,
        name: `${onlyName}_seller-delivery`,
        component: () => import(`../views/${viewType}/member/SellerDeliveryView.vue`)
      },
      {
        // 經銷商雲倉庫 – 換貨申請紀錄
        path: `${pathName}/member/exchange`,
        name: `${onlyName}_exchange`,
        component: () => import(`../views/${viewType}/member/ExchangeView.vue`)
      },
      {
        //  經銷商雲倉庫 – 換貨申請
        path: `${pathName}/member/ex_request`,
        name: `${onlyName}_ex_request`,
        component: () => import(`../views/${viewType}/member/ExRequestView.vue`)
      },
      {
        // 會員中心
        path: `${pathName}/member/account_share`,
        name: `${onlyName}_account_share`,
        component: () => import(`../views/${viewType}/member/AccountShareView.vue`)
      }
    ]
  }
  return memberObject
}

const router = createRouter({ history: createWebHistory(), routes })

// 捕获懒加载 chunk 失败（线上更新后旧缓存导致 404），自动刷新加载最新版本


// 在跳頁前的動作
router.beforeEach(function (to, from, next) {
  const token = store.state.token
  if (to['name'].includes('member') == 1) token === '' ? next({ path: `/login` }) : next()
  next()
  setTimeout(() => window.scrollTo(0, 0), 100)
})


export default router
